import { defineComponent, ref, computed } from "vue";
import slugify from "./component-library82.mjs";
import { getConfig } from "./component-library2.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "link-button",
  props: {
    tag: { default: "a" },
    tealiumName: { default: void 0 },
    tealiumSuffix: { default: void 0 },
    disabled: { type: Boolean },
    primary: { type: Boolean },
    secondary: { type: Boolean },
    noStyling: { type: Boolean },
    transparent: { type: Boolean },
    transparentLight: { type: Boolean },
    transparentPrimary: { type: Boolean },
    outline: { type: Boolean },
    outlineLight: { type: Boolean },
    outlinePrimary: { type: Boolean },
    borderless: { type: Boolean },
    text: { type: Boolean },
    textNeutral: { type: Boolean },
    isWide: { type: Boolean },
    to: { default: void 0 },
    isExternal: { type: Boolean },
    sameWindow: { type: Boolean },
    smallPadding: { type: Boolean },
    large: { type: Boolean },
    medium: { type: Boolean },
    label: { default: void 0 },
    type: { default: void 0 },
    iconOnly: { type: Boolean },
    checked: { type: Boolean }
  },
  emits: ["click"],
  setup(__props, { expose, emit }) {
    const props = __props;
    const linkElement = ref(null);
    const classes = computed(() => {
      const modifier = [];
      modifier.push("link-button btn");
      if (props.isWide)
        modifier.push("btn--is-wide");
      if (props.primary)
        modifier.push("btn--primary");
      if (props.secondary)
        modifier.push("btn--secondary");
      if (props.noStyling)
        modifier.push("btn--no-style");
      if (props.outline)
        modifier.push("btn--outline");
      if (props.outlineLight)
        modifier.push("btn--outline-light");
      if (props.outlinePrimary)
        modifier.push("btn--outline-primary");
      if (props.transparent)
        modifier.push("btn--transparent");
      if (props.transparentLight)
        modifier.push("btn--transparent-light");
      if (props.transparentPrimary)
        modifier.push("btn--transparent-primary");
      if (props.text)
        modifier.push("btn--text");
      if (props.textNeutral)
        modifier.push("btn--text btn--text-neutral");
      if (props.disabled)
        modifier.push("btn--disabled");
      if (props.smallPadding)
        modifier.push("btn--small-padding");
      if (props.isExternal)
        modifier.push("link--external");
      if (props.large)
        modifier.push("btn--large");
      if (props.medium)
        modifier.push("btn--medium");
      if (props.iconOnly)
        modifier.push("btn--icon-only");
      if (props.checked)
        modifier.push("btn--checked");
      if (!props.primary && !props.secondary && !props.outline && !props.outlineLight && !props.outlinePrimary && !props.transparent && !props.transparentLight && !props.transparentPrimary && !props.text && !props.textNeutral && !props.noStyling) {
        modifier.push("btn--default");
      }
      return modifier;
    });
    const linkType = computed(() => {
      if (props.text)
        return "text";
      return "button";
    });
    const dataTealium = computed(() => {
      var _a;
      let dasherizedText;
      if (props.label)
        dasherizedText = slugify(props.label);
      else if ((_a = linkElement.value) == null ? void 0 : _a.textContent)
        dasherizedText = slugify(linkElement.value.textContent);
      if (props.tealiumName)
        dasherizedText = slugify(props.tealiumName);
      if (!dasherizedText)
        return null;
      if (props.tealiumSuffix) {
        return `content.${linkType.value}.${dasherizedText}.${slugify(props.tealiumSuffix)}`;
      }
      return `content.${linkType.value}.${dasherizedText}`;
    });
    const tagComponent = computed(() => {
      var _a;
      if (props.tag === "nuxt-link" && ((_a = getConfig()) == null ? void 0 : _a.nuxtLink)) {
        return getConfig().nuxtLink;
      }
      return props.tag;
    });
    const onClick = (e) => {
      var _a, _b, _c;
      if (((_b = (_a = getConfig()) == null ? void 0 : _a.tealium) == null ? void 0 : _b.link) && dataTealium.value) {
        (_c = getConfig().tealium) == null ? void 0 : _c.link({ wt_link_id: dataTealium.value });
      }
      emit("click", e);
    };
    expose({ classes, linkType, dataTealium });
    return { __sfc: true, props, linkElement, emit, classes, linkType, dataTealium, tagComponent, onClick };
  }
});
export {
  _sfc_main as default
};
